<template>
    <span class="text-danger" v-if="mostrarBtnExcluir">
        <i
            class="fa fa-trash fa-lg icon-button ml-1"
            title="Excluir Comprometimento"
            @click.stop="confirmarExcluir()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        natureza: {
            type: Object,
            default: () => ({})
        },

        movimentosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Exclusão de Comprometimento',
                html: `Confirma a exclusão do comprometimento de ID <b>${this.natureza.idRm}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            this.movimentosServicos
                .excluirComprometimentoDespViagem(
                    this.natureza.codContratacao,
                    this.natureza.nome.substring(0, 1)
                )
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir comprometimento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnExcluir() {
            return (
                this.$temAcesso('CRED-UABS-CONT-02') &&
                (this.natureza.status == 'COMPROMETIDO' ||
                    this.natureza.status == 'ATUALIZAR COMPROMETIMENTO') &&
                this.natureza.statusFin != 'F'
            )
        }
    }
}
</script>
